import type {Card, _Card} from './card';
import type {ScatterPlot3DCard} from './scatter-plot3-dcard';
import type {Variable} from './../models/variable';

/**
 * Generated from com.dataiku.dip.eda.worksheets.cards.TrivariateCard
 */
export interface _TrivariateCard extends _Card {
    xColumn: Variable;
    yColumn: Variable;
    zColumn: Variable;
}

export type TrivariateCard = ScatterPlot3DCard;

export namespace TrivariateCard {
    export const type = ['scatter_plot_3d'] as const;
}

/** @deprecated Use Card.isTrivariateCard() */ export function isTrivariateCard(toTest: Card): toTest is TrivariateCard { return (TrivariateCard.type as readonly unknown[]).includes(toTest['type']); }